import React from 'react';
import { HotelOffersTermsDrawer } from '@americanexpress/consumer-travel-base';
import { useReactlytics } from '@americanexpress/reactlytics';
import { HotelOfferData } from '../../types/PersonalizedMarketingArticles';

type TermsDrawerProps = {
  article: HotelOfferData;
  isTermsDrawerOpen: boolean;
  handleCloseDrawer: () => void;
};

export const TermsDrawer = ({
  article,
  isTermsDrawerOpen,
  handleCloseDrawer,
}: TermsDrawerProps) => {
  const { track } = useReactlytics();

  return (
    <HotelOffersTermsDrawer
      program={article.program}
      isDrawerOpen={isTermsDrawerOpen}
      handleCloseDrawer={() => {
        track({
          event: {
            element: article.program,
            type: 'click',
            detail: 'Close:Terms Panel',
          },
        });
        handleCloseDrawer();
      }}
      title={article.offerText}
      subtitle={article.title}
      body={article.termsDrawer?.body}
      promoCode={article.termsDrawer?.promoCode}
      offerDetails={article.termsDrawer?.offerDetails}
      tnc={article.termsDrawer?.tnc}
    />
  );
};
